import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth/auth';

export const authGuard: CanActivateFn = (_route, state) => {
    const auth = inject(Auth);
    const router = inject(Router);

    if (auth.possuiTokenValido()) return true;

    auth.logout();
    return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
